import { createAction } from '@reduxjs/toolkit'
import Token from 'type/Token'

export const updateSelectedToken = createAction<{ token: Token | undefined }>('token/updateSelectedToken')
export const updateTokenAmount = createAction<{ amount: string }>('token/updateTokenAmount')
export const clearTokenCache = createAction<void>('token/clearTokenCache')
